import React from 'react'
import { useHistory } from 'react-router-dom'
import { get as _get } from 'lodash'
import { Helmet } from 'react-helmet'
import { Button } from '../ui/button'
import useAuth from '../../utilities/hooks/useAuth'
import { openCrispChat } from '../../utilities/crisp'

function BrokenSkateIllustration() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md mx-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="200" cy="240" rx="120" ry="20" fill="#ddd6fe" opacity="0.4" />

      <rect x="120" y="180" width="160" height="25" rx="5" fill="#8b5cf6" />

      <path d="M 140 180 L 135 140" stroke="#6366f1" strokeWidth="8" strokeLinecap="round" />
      <path d="M 170 180 L 165 150" stroke="#6366f1" strokeWidth="8" strokeLinecap="round" />
      <path d="M 200 180 L 200 145" stroke="#6366f1" strokeWidth="8" strokeLinecap="round" />
      <path d="M 230 180 L 235 150" stroke="#6366f1" strokeWidth="8" strokeLinecap="round" />
      <path d="M 260 180 L 265 140" stroke="#6366f1" strokeWidth="8" strokeLinecap="round" />

      <circle cx="135" cy="135" r="8" fill="#a78bfa" />
      <circle cx="165" cy="145" r="8" fill="#a78bfa" />
      <circle cx="200" cy="140" r="8" fill="#a78bfa" />
      <circle cx="235" cy="145" r="8" fill="#a78bfa" />
      <circle cx="265" cy="135" r="8" fill="#a78bfa" />

      <path d="M 190 205 L 185 225 L 175 218 L 180 202" fill="#dc2626" stroke="#b91c1c" strokeWidth="2" />
      <path d="M 180 208 L 220 212" stroke="#dc2626" strokeWidth="3" strokeLinecap="round" />

      <circle cx="140" cy="190" r="15" fill="#4f46e5" />
      <circle cx="260" cy="190" r="15" fill="#4f46e5" />
      <rect x="135" y="190" width="10" height="50" fill="#4f46e5" />
      <rect x="255" y="190" width="10" height="50" fill="#4f46e5" />
      <rect x="130" y="235" width="20" height="10" rx="2" fill="#312e81" />
      <rect x="250" y="235" width="20" height="10" rx="2" fill="#312e81" />

      <path d="M 100 100 L 115 115" stroke="#fbbf24" strokeWidth="4" strokeLinecap="round" />
      <path d="M 115 100 L 100 115" stroke="#fbbf24" strokeWidth="4" strokeLinecap="round" />

      <path d="M 290 110 L 305 125" stroke="#fbbf24" strokeWidth="4" strokeLinecap="round" />
      <path d="M 305 110 L 290 125" stroke="#fbbf24" strokeWidth="4" strokeLinecap="round" />

      <circle cx="320" cy="90" r="5" fill="#fcd34d" opacity="0.6" />
      <circle cx="80" cy="130" r="4" fill="#fcd34d" opacity="0.6" />
      <circle cx="340" cy="140" r="3" fill="#fcd34d" opacity="0.5" />

      <path d="M 280 200 Q 300 190 310 210" stroke="#e0e7ff" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
    </svg>
  )
}

function ServerErrorPage() {
  const history = useHistory()
  const { currentUser, isSignedIn } = useAuth()

  function handleGoHome() {
    history.push('/')
  }

  function handleGoToDashboard() {
    if (!isSignedIn || !currentUser) {
      history.push('/')
      return
    }

    const facilitiesUsers = currentUser && Array.isArray(currentUser.facilitiesUsers) ? currentUser.facilitiesUsers : []
    const coachFacilitiesUser = facilitiesUsers.find((user) => user.admin || user.coach)

    if (coachFacilitiesUser) {
      history.push(`/facilities/${coachFacilitiesUser.facility.id}/calendar`)
      return
    }

    const isParent = !!_get(currentUser, 'students.length')
    if (isParent) {
      history.push(`/guardians/${currentUser.id}/students`)
      return
    }

    history.push('/')
  }

  function handleContactSupport() {
    openCrispChat()
  }

  return (
    <>
      <Helmet>
        <title>500 - Server Error | Leevo</title>
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-purple-100 flex items-center justify-center p-4">
        <div className="max-w-2xl w-full text-center">
          <div className="mb-8">
            <BrokenSkateIllustration />
          </div>

          <div className="mb-6">
            <h1 className="text-8xl md:text-9xl font-bold bg-gradient-to-r from-purple-600 to-purple-400 bg-clip-text text-transparent mb-4">
              500
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-3">Something broke on our end</h2>
            <p className="text-lg text-gray-600 max-w-md mx-auto">
              Our skates need some maintenance! We&apos;re working on fixing this issue. Please try again in a few
              moments.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={handleGoHome}
              variant="default"
              size="lg"
              className="bg-purple-600 hover:bg-purple-700 text-white"
            >
              Go Home
            </Button>
            {isSignedIn && (
              <Button
                onClick={handleGoToDashboard}
                variant="outline"
                size="lg"
                className="border-purple-600 text-purple-600 hover:bg-purple-50"
              >
                Go to Dashboard
              </Button>
            )}
            <Button
              onClick={handleContactSupport}
              variant="ghost"
              size="lg"
              className="text-purple-600 hover:bg-purple-100"
            >
              Contact Support
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServerErrorPage
